let faqPath = [];

const faqArticles = window.HelpCenter.articles;
const faqCategories = window.HelpCenter.categories;
const faqSectionGroups = window.HelpCenter.sectionGroups;
const faqTopics = window.HelpCenter.topics;

/* function helpers */
function updateUrl(type, id){

    const url = new URL(window.location.href);

    url.search = '';

    if(type && id){
        url.searchParams.set(type, id);
    }

    if(url.href !== window.location.href){
        history.pushState({}, '', url);
    }

}
function renderBreadcrumb() {

    let html = '';

    faqPath.forEach((item,index)=>{

    if(index>0) html += '<span>/</span>';

    html += `
        <span
            class="faq-breadcrumb-item"
            data-index="${index}">
            ${item.title}
        </span>
    `;

});

    $('.faq-breadcrumb').html(html);

}

function renderHome(){

    let html='';

    faqCategories.forEach(category=>{

        html += `
            <div
                class="faq-card faq-category"
                data-id="${category.id}">

                <div class="faq-card-title">
                    ${category.title}
                </div>

                ${
                    category.description
                    ? `<div class="faq-card-description">${category.description}</div>`
                    : ''
                }

            </div>
        `;

    });

    $('.faq-view').html(`
        <div class="faq-home-grid">
            ${html}
        </div>
    `);

    faqPath = [{
        type:'home',
        title:'Home'
    }];

    renderBreadcrumb();
    showHomeHeader();
}
function renderArticle(article){

    let html = `
        <div class="faq-article">

            <h2>${article.title}</h2>

            <div class="faq-content">
                ${article.content}
            </div>

        </div>
    `;

    $('.faq-view').html(html);

}
/* search function */
function performSearch(query, input){

    query = query.trim().toLowerCase();

    if(query === ''){

        $('.faq-search-results')
            .empty()
            .hide();

        return;
    }

    const results = [];

    // Categories
    faqCategories.forEach(category=>{

        const text = [
            category.title,
            category.display_title,
            category.description
        ].join(' ').toLowerCase();

        if(text.includes(query)){

            results.push({
                type:'category',
                id:category.id,
                title:category.display_title || category.title,
                subtitle:'Category'
            });

        }

    });

    // Topics
    faqTopics.forEach(topic=>{

        const category = faqCategories.find(x=>x.id == topic.category);

        const text = [
            topic.title,
            topic.display_title,
            topic.description
        ].join(' ').toLowerCase();

        if(text.includes(query)){

            results.push({
                type:'topic',
                id:topic.id,
                title:topic.display_title || topic.title,
                subtitle:category
                    ? category.title
                    : 'Topic'
            });

        }

    });

    // Section Groups
    faqSectionGroups.forEach(group=>{

        const topic = faqTopics.find(x=>x.id == group.topic);
        const category = faqCategories.find(x=>x.id == group.category);

        const text = [
            group.title,
            group.display_title,
            group.description
        ].join(' ').toLowerCase();

        if(text.includes(query)){

            let path = [];

            if(category) path.push(category.title);
            if(topic) path.push(topic.display_title || topic.title);

            results.push({
                type:'group',
                id:group.id,
                title:group.display_title || group.title,
                subtitle:path.join(' > ')
            });

        }

    });

    // Articles
    faqArticles.forEach(article=>{

        const group = faqSectionGroups.find(x=>x.id == article.section_group);
        const topic = group ? faqTopics.find(x=>x.id == group.topic) : null;
        const category = group
            ? faqCategories.find(x=>x.id == group.category)
            : null;

        const text = [
            article.title,
            article.display_title,
            article.summary,
            article.content
        ].join(' ').toLowerCase();

        if(text.includes(query)){

            let path = [];

            if(category) path.push(category.title);
            if(topic) path.push(topic.display_title || topic.title);
            if(group) path.push(group.display_title || group.title);

            results.push({
                type:'article',
                id:article.id,
                title:article.display_title || article.title,
                subtitle:path.join(' > ')
            });

        }

    });

    renderSearchDropdown(results, query, input);

}

function renderSearchDropdown(results, query, input){

    const icons = {
        article:'📄',
        topic:'📂',
        group:'📁',
        category:'📦'
    };

    let html = '';

    if(results.length){

        results.slice(0,8).forEach(result=>{

            html += `
                <div
                    class="faq-search-item"
                    data-type="${result.type}"
                    data-id="${result.id}">

                    <div class="faq-search-item-title">
                        <span class="faq-search-icon">
                            ${icons[result.type]}
                        </span>

                        ${result.title}
                    </div>

                    ${
                        result.subtitle
                        ? `
                        <div class="faq-search-item-subtitle">
                            ${result.subtitle}
                        </div>
                        `
                        : ''
                    }

                </div>
            `;

        });

        if(results.length > 8){

            html += `
                <div class="faq-search-more">
                    More results for "<strong>${query}</strong>"
                </div>
            `;

        }

    }else{

        html = `
            <div class="faq-search-empty">
                No results found
            </div>
        `;

    }

    const searchBox = input
        ? input.closest('.faq-search')
        : $('.faq-search').first();

    searchBox
        .find('.faq-search-results')
        .html(html)
        .show();

}
/* end search function */
/* page render for card grouping */
function renderSectionGroup(group){

    const articles = faqArticles
        .filter(article => article.section_group == group.id)
        .sort((a,b)=>a.sort_order-b.sort_order);

    const mobileCols = Math.min(
        (group.mobile_layout || '1 Column') == '2 Columns' ? 2 : 1,
        articles.length
    );

    let html = `
        <div
            class="faq-article-cards"
            data-desktop="${group.desktop_layout || '3 Columns'}"
            data-mobile="${mobileCols} Column${mobileCols > 1 ? 's' : ''}">
    `;

    articles.forEach(article=>{

        html += `
            <div
                class="faq-card faq-article-link"
                data-id="${article.id}">

                <div class="faq-card-title">
                    ${article.title}
                </div>

                ${
                    article.summary
                    ? `
                    <div class="faq-card-summary">
                        ${article.summary}
                    </div>
                    `
                    : ''
                }

            </div>
        `;

    });

    html += `
        </div>
    `;

    $('.faq-view').html(html);

}
function openCategory(categoryId, pushHistory = true){

    const categoryObj = faqCategories.find(x => x.id == categoryId);

    // Redirect if Link URL is configured
    if (categoryObj.link_url) {
        window.location.href = categoryObj.link_url;
        return;
    }

    faqPath = [
        {
            type:'home',
            title:'Home'
        },
        {
            type:'category',
            title:categoryObj.title,
            category:categoryId
        }
    ];

    renderBreadcrumb();
    if(pushHistory){
        updateUrl('category', categoryId);
    }

    showInnerHeader(
        categoryObj.title,
        categoryObj.description || ''
    );

    renderCategory(categoryId);
    window.scrollTo(0, 0);

}

function openTopic(topicId, pushHistory = true){

    const topic = faqTopics.find(x => x.id == topicId);

    faqPath = [
        {
            type:'home',
            title:'Home'
        },
        {
            type:'category',
            title:(faqCategories.find(x=>x.id==topic.category) || {}).title,
            category:topic.category
        },
        {
            type:'topic',
            title:topic.display_title || topic.title,
            id:topic.id,
            category:topic.category
        }
    ];

    renderBreadcrumb();
    if(pushHistory){
        updateUrl('topic', topic.id);
    }

    showInnerHeader(
        topic.display_title || topic.title,
        topic.description || ''
    );

    renderTopic(topic);
    window.scrollTo(0, 0);

}

function openSectionGroup(groupId, pushHistory = true){

    const group = faqSectionGroups.find(x => x.id == groupId);

    const topic = group.topic
        ? faqTopics.find(x=>x.id==group.topic)
        : null;

    const categoryId = group.category || (topic ? topic.category : null);

    faqPath = [
        {
            type:'home',
            title:'Home'
        }
    ];

    if(categoryId){

        faqPath.push({
            type:'category',
            title:(faqCategories.find(x=>x.id==categoryId) || {}).title,
            category:categoryId
        });

    }

    if(topic){

        faqPath.push({
            type:'topic',
            title:topic.display_title || topic.title,
            id:topic.id,
            category:topic.category
        });

    }

    faqPath.push({
        type:'section-group',
        title:group.display_title || group.title,
        id:group.id
    });

    renderBreadcrumb();
    if(pushHistory){
        updateUrl('group', group.id);
    }

    showInnerHeader(
        group.display_title || group.title,
        group.description || ''
    );

    renderSectionGroup(group);
    window.scrollTo(0, 0);

}

function openArticle(articleId, pushHistory = true){

    const article = faqArticles.find(x => x.id == articleId);

    if(!article){
        return;
    }

    // Article may belong to either:
    // 1. Section Group → Topic → Category
    // 2. Topic → Category (Render Directly)
    const group = article.section_group
        ? faqSectionGroups.find(x => x.id == article.section_group)
        : null;

    const topic = article.topic
        ? faqTopics.find(x => x.id == article.topic)
        : (
            group && group.topic
                ? faqTopics.find(x => x.id == group.topic)
                : null
        );

    const categoryId = group
        ? (group.category || (topic ? topic.category : null))
        : (topic ? topic.category : null);

    faqPath = [
        {
            type:'home',
            title:'Home'
        }
    ];

    if(categoryId){

        faqPath.push({
            type:'category',
            title:(faqCategories.find(x=>x.id==categoryId) || {}).title,
            category:categoryId
        });

    }

    if(topic){

        faqPath.push({
            type:'topic',
            title:topic.display_title || topic.title,
            id:topic.id,
            category:topic.category
        });

    }

    if(group){

        faqPath.push({
            type:'section-group',
            title:group.display_title || group.title,
            id:group.id
        });

    }

    faqPath.push({
        type:'article',
        title:article.display_title || article.title,
        id:article.id,
        section_group:article.section_group,
        topic:article.topic
    });

    renderBreadcrumb();

    if(pushHistory){
        updateUrl('article', article.id);
    }

    showInnerHeader(
        article.display_title || article.title,
        article.description || ''
    );

    renderArticle(article);

    window.scrollTo(0, 0);

}
function showHomeHeader(){

    $('.faq-header-home').show();
    $('.faq-home-links-wrapper, .faq-section-title, .help-center-home, .footer.shopify-section-group-footer-group, #shopify-section-header, .announcement-heading').show();

    $('.faq-header-inner').hide();

    $('.faq-view-wrap').removeClass('inner');
}

function showInnerHeader(title, description=''){

    $('.faq-header-home').hide();
    $('.faq-home-links-wrapper, .faq-section-title, .help-center-home, .footer.shopify-section-group-footer-group, #shopify-section-header, .announcement-heading').hide();

    $('.faq-header-inner').show();
    $('.faq-page-title').html(title);
    $('.faq-page-description').html(description);

    $('.faq-view-wrap').addClass('inner');

}

function buildCategoryGroups(categoryId){

    return faqSectionGroups
        .filter(group =>
            group.category == categoryId &&
            !group.topic
        )
        .sort((a,b)=>a.sort_order-b.sort_order)
        .map(group=>({

            ...group,

            topics: faqTopics
                .filter(topic =>
                    topic.category == categoryId &&
                    topic.section_group == group.id
                )
                .sort((a,b)=>a.sort_order-b.sort_order),

            articles: faqArticles
                .filter(article =>
                    article.section_group == group.id
                )
                .sort((a,b)=>a.sort_order-b.sort_order)

        }));

}
function buildTopicGroups(topicId){

    return faqSectionGroups
        .filter(group =>
            group.topic == topicId
        )
        .sort((a,b)=>a.sort_order-b.sort_order)
        .map(group=>({

            ...group,

            articles: faqArticles
                .filter(article =>
                    articleBelongsToGroup(article, group.id)
                )
                .sort((a,b)=>a.sort_order-b.sort_order)

        }));

}
function articleBelongsToGroup(article, groupId){

    // Existing single Section Group field
    if(article.section_group == groupId){
        return true;
    }

    // New multiple Section Group List field
    if(
        Array.isArray(article.section_group_list) &&
        article.section_group_list.includes(groupId)
    ){
        return true;
    }

    return false;
}
function renderCategory(categoryId){

    const groups = buildCategoryGroups(categoryId);

    renderGroupedChildren(groups, 'category');

}
function renderTopic(topic){

    if(topic.render_directly){

        const articles = faqArticles
            .filter(article => article.topic == topic.id)
            .sort((a, b) => a.sort_order - b.sort_order);

        const desktopLayout = topic.desktop_layout || '3 Columns';
        const mobileLayout = topic.mobile_layout || '1 Column';

        let html = `
            <div
                class="faq-article-cards"
                data-desktop="${desktopLayout}"
                data-mobile="${mobileLayout}">
        `;

        articles.forEach(article => {

            html += `
                <div
                    class="faq-card faq-article-link"
                    data-id="${article.id}">

                    <div class="faq-card-title">
                        ${article.title}
                    </div>

                    ${
                        article.summary
                            ? `
                                <div class="faq-card-summary">
                                    ${article.summary}
                                </div>
                            `
                            : ''
                    }

                </div>
            `;

        });

        html += `
            </div>
        `;

        $('.faq-view').html(html);

        return;
    }

    // Existing behavior
    const groups = buildTopicGroups(topic.id);

    renderGroupedChildren(groups, 'topic');

}
function renderGroupedChildren(groups, level){

    let left = '';
    let right = '';

    groups.forEach((group, index)=>{

        let groupHtml = '';

        if(level == 'category'){

            if(group.display_type.toLowerCase() == 'links'){
                groupHtml = renderCategoryLinks(group);
            }else{
                groupHtml = renderCategoryCards(group);
            }

        }else{

            if(group.display_type.toLowerCase() == 'links'){
                groupHtml = renderArticleLinks(group);
            }else{
                groupHtml = renderArticleCards(group);
            }

        }

        if(index % 2 === 0){
            left += groupHtml;
        }else{
            right += groupHtml;
        }

    });

    $('.faq-view').html(`
        <div class="faq-columns">
            <div class="faq-column">
                ${left}
            </div>

            <div class="faq-column">
                ${right}
            </div>
        </div>
    `);

}
function renderCategoryCards(group){

    let html = `
        <div class="faq-group">

            <div class="faq-group-title">
                ${group.display_title || group.title}
            </div>

            <div class="faq-group-items">
    `;

    // Has Topics
    if(group.topics && group.topics.length){

        group.topics.forEach(topic=>{

            html += `
                <div
                    class="faq-topic"
                    data-id="${topic.id}">

                    ${topic.display_title || topic.title}

                </div>
            `;

        });

    }

    // No Topics, show Articles instead
    else if(group.articles && group.articles.length){

        const previewLimit = parseInt(group.preview_limit);

        const preview =
            Number.isInteger(previewLimit) && previewLimit > 0
                ? group.articles.slice(0, previewLimit)
                : group.articles;

        preview.forEach(article=>{

            html += `
                <div
                    class="faq-article-link faq-group-item-preview"
                    data-id="${article.id}">

                    ${article.display_title || article.title}

                </div>
            `;

        });

    }

    html += `
            </div>

        </div>
    `;

    return html;

}
function renderCategoryLinks(group){

    let html = `
        <div class="faq-link-group">

            <div class="faq-link-group-title">
                ${group.display_title || group.title}
            </div>

            <div class="faq-link-list">
    `;

    // Has Topics
    if(group.topics && group.topics.length){

        group.topics.forEach(topic=>{

            html += `
                <div
                    class="faq-link-item faq-topic"
                    data-id="${topic.id}">

                    ${topic.display_title || topic.title}

                </div>
            `;

        });

    }

    // No Topics, show Articles
    else if(group.articles && group.articles.length){

        group.articles.forEach(article=>{

            html += `
                <div
                    class="faq-link-item faq-article-link"
                    data-id="${article.id}">

                    ${article.display_title || article.title}

                </div>
            `;

        });

    }

    html += `
            </div>

        </div>
    `;

    return html;

}
function renderArticleLinks(group){

    let html = `
        <div class="faq-link-group">

            <div class="faq-link-group-title">
                ${group.display_title || group.title}
            </div>

            <div class="faq-link-list">
    `;

    group.articles.forEach(article=>{

        html += `
            <div
                class="faq-link-item faq-article-link"
                data-id="${article.id}">

                ${article.display_title || article.title}

            </div>
        `;

    });

    html += `
            </div>

        </div>
    `;

    return html;

}
function renderArticleCards(group){

    const previewLimit = parseInt(group.preview_limit);

    const preview =
        Number.isInteger(previewLimit) && previewLimit > 0
            ? group.articles.slice(0, previewLimit)
            : group.articles;

    let html = `
        <div
            class="faq-group faq-section-group-card"
            data-id="${group.id}">

            <div class="faq-group-title">
                ${group.display_title || group.title}
            </div>

            <div class="faq-group-items">
    `;

    preview.forEach(article=>{

        html += `
            <div class="faq-group-item-preview">
                ${article.title}
            </div>
        `;

    });

    html += `
            </div>

        </div>
    `;

    return html;

}

/* use functions */
function loadFromUrl(){

    const params = new URLSearchParams(window.location.search);

    if(params.has('article')){
        openArticle(params.get('article'), false);
        return;
    }

    if(params.has('group')){
        openSectionGroup(params.get('group'), false);
        return;
    }

    if(params.has('topic')){
        openTopic(params.get('topic'), false);
        return;
    }

    if(params.has('category')){
        openCategory(params.get('category'), false);
        return;
    }

    renderHome();

}
$(document).ready(function(){

    loadFromUrl();

});
$(document).on('click','.faq-category',function(){

    openCategory($(this).data('id'));

});

$(document).on('click','.faq-topic',function(){

    openTopic($(this).data('id'));

});
$(document).on('click','.faq-section-group-card',function(){

    openSectionGroup($(this).data('id'));

});
$(document).on('click','.faq-article-link',function(){

    openArticle($(this).data('id'));

});
$(document).on('click','.faq-home-link',function(){

    renderHome();
    updateUrl();

});
$(document).on('click', '.faq-breadcrumb-item', function () {

    const index = $(this).data('index');
    const item = faqPath[index];

    switch(item.type){

        case 'home':
            renderHome();
            updateUrl();
            break;

        case 'category':
            openCategory(item.category, false);
            updateUrl('category', item.category);
            break;

        case 'topic':
            openTopic(item.id, false);
            updateUrl('topic', item.id);
            break;

        case 'section-group':
            openSectionGroup(item.id, false);
            updateUrl('group', item.id);
            break;

        case 'article':
            openArticle(item.id, false);
            updateUrl('article', item.id);
            break;

    }

});
$(document).on('keyup', '.faq-search-input', function(){

    performSearch($(this).val(), $(this));

});

$(document).on('focus', '.faq-search-input', function(){

    performSearch($(this).val(), $(this));

});

$(document).on('click', function(e){

    if(!$(e.target).closest('.faq-search').length){
        $('.faq-search-results').hide();
    }

    if(!$(e.target).closest('.faq-inner-search').length){
        $('.faq-inner-search').removeClass('active');
    }

});
$(document).on('click', '.faq-search', function(e){
    e.stopPropagation();
});
$(document).on('mousedown', '.faq-search-item', function(e){

    e.preventDefault();

    const type = $(this).data('type');
    const id = $(this).data('id');

    switch(type){

        case 'article':
            openArticle(id);
            break;

        case 'topic':
            openTopic(id);
            break;

        case 'group':
            openSectionGroup(id);
            break;

        case 'category':
            openCategory(id);
            break;

    }

});
$(document).on('click', '.faq-search-toggle', function(e){

    e.preventDefault();
    e.stopPropagation();

    const wrapper = $(this).closest('.faq-inner-search');

    $('.faq-inner-search')
        .not(wrapper)
        .removeClass('active');

    wrapper.toggleClass('active');

    if(wrapper.hasClass('active')){

        wrapper
            .find('.faq-search-input')
            .trigger('focus');

    }

});
window.addEventListener('popstate', function () {
    loadFromUrl();
});